import { css } from 'styled-components'

export const stepperStyle = css`
	padding: 0;
`

export const stepVerticalConnectorStyle = css`
	margin: 4px 0 4px 14px;
	padding: 9.5px 0 9.5px 20px;
	border-left: 1px solid ${({ theme }) => theme.palette.primary.main};
`

export const stepHorizontalConnectorStyle = css`
	top: 15px;
`

export const stepSecondaryLabelStyle = css`
	.MuiStepIcon-root {
		border-radius: 50%;

		.MuiStepIcon-text {
			fill: ${({ theme }) => theme.palette.content.dark};
		}
	}
`

export const stepIconStyle = css`
	color: ${({ theme }) => theme.palette.common.white};
	position: relative;
	display: inline-flex;

	.MuiCircularProgress-root {
		border: 2px solid #ffe49f;
		border-radius: 50%;
	}

	.MuiStepIcon-root {
		position: absolute;
		top: 3px;
		left: 3px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: inherit;
	}

	.MuiStepIcon-text {
		fill: #ff9b04;
	}
`
export const stepStyle = css`
	cursor: pointer;
	padding: 0;
	width: ${(props) => `${100 / props.totalStep}%`};

	&.MuiStep-completed {
		.MuiCircularProgress-root {
			border: 2px solid ${({ theme }) => theme.palette.background.element.medium};
		}

		.MuiStepIcon-text {
			fill: ${({ theme }) => theme.palette.primary.main};
		}
	}
`
